import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import AppErrorBoundary from './components/AppErrorBoundary';
import { installGlobalErrorMonitor } from './utils/globalErrorMonitor';
import { initPerfMonitor } from './utils/perfMonitor';
import { initSessionMonitor } from './utils/sessionMonitor';

// Monitoring : erreurs JS non gérées et performance réelle (voir docs/monitoring/README.md)
installGlobalErrorMonitor();
initPerfMonitor();
initSessionMonitor();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppErrorBoundary>
      <App />
    </AppErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
